<template>
  <div class="air__utils__scrollTable mb-4">
    <a-table
      :rowKey="record => record.id"
      :columns="columns"
      :dataSource="data"
      :pagination="false"
      :scroll="{ x: true }"
      :loading="loading"
       @change="handleTableChange"
    >
      <template slot="sno" slot-scope="text, record, index">
        <span class="font-weight-bold">{{ index + 1 }}</span>
      </template>
      <template slot="approval_type" slot-scope="approval_type">
        <span class="font-weight-bold">{{ approval_type.approval_type }}</span>
      </template>

      <template slot="submitted_by" slot-scope="submitted_by">
        <span class="font-weight-bold">
          {{ submitted_by.first_name }} {{ submitted_by.last_name }}
        </span>
      </template>

      <template slot="submitted_at" slot-scope="submitted_at">
        <span>{{ formatDate(submitted_at) }}</span>
      </template>

      <template slot="assigned_to" slot-scope="assigned_to">
        <span class="font-weight-bold">
          {{ assigned_to.first_name }} {{ assigned_to.last_name }}
        </span>
      </template>

      <template slot="class" slot-scope="record">
        <span class="font-weight-bold">{{ record.school_class.name }}</span>
      </template>

      <template slot="section" slot-scope="record">
        <span class="font-weight-bold">{{ record.section.name }}</span>
      </template>

      <template slot="action_required" slot-scope="action_required">
        <span class="font-weight-bold">{{ action_required }}</span>
      </template>

      <template slot="status" slot-scope="status">
        <a-tag :color="statusColor(status)">
          {{ status }}
        </a-tag>
      </template>

      <template slot="action" slot-scope="text, record">
        <a-tooltip
              placement="top"
              title="View Details"
            >
              <a href="javascript:;" class="btn btn-sm btn-primary mr-2"
                @click="showViewModal(record)"
              >
                  <i class="btn-addon-icon fe fe-eye" />
              </a>
            </a-tooltip>
      </template>
    </a-table>
    <a-modal
     v-model="viewModalVisible"
     title="Approval Details"
     :footer="null"
     width="600px"
    >
    <a-form layout="vertical">
     <div class="row mb-3">
      <div class="col">
        <strong>For Date:</strong>
        {{ selectedRecord.for_date ? formatDateOnly(selectedRecord.for_date) : '-' }}
      </div>
      <div class="col">
        <strong>Approval Type:</strong> {{ selectedRecord.approval_type && selectedRecord.approval_type.approval_type || '-' }}
      </div>
     </div>
    <div class="row mb-3">
      <div class="col">
        <strong>Status:</strong>
        <a-tag :color="statusColor(selectedRecord.status)">
          {{ selectedRecord.status }}
        </a-tag>
      </div>
      <div class="col">
        <strong>Assigned To:</strong>
        {{ selectedRecord.assigned_to && `${selectedRecord.assigned_to.first_name} ${selectedRecord.assigned_to.last_name}` || '-' }}
    </div>
    </div>
    <div class="row mb-3">
     <div class="col">
      <strong>Class:</strong> {{ selectedRecord.school_class && selectedRecord.school_class.name || '-' }}
     </div>
      <div class="col">
      <strong>Section:</strong> {{ selectedRecord.section && selectedRecord.section.name || '-' }}
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
      <strong>Submitted By:</strong> {{ submittedByName }}
      </div>
      <div class="col">
      <strong>Submitted At:</strong> {{ formatDate(selectedRecord.submitted_at) }}
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <strong>Action Required:</strong> {{ selectedRecord.action_required || '-' }}
      </div>
     </div>
    <p><strong>Description:</strong></p>
    <p class="mb-4">{{ selectedRecord.description || '-' }}</p>
    <div class="row mb-3" v-if="selectedRecord.remarks">
      <div class="col">
        <strong>Remark:</strong>
          <a-alert
          :message="selectedRecord.remarks"
          type="warning"
          show-icon
          class="mt-2"
        />
      </div>
    </div>
    <div class="text-right mt-4">
      <a-popconfirm
      title="Are you sure you want to approve?"
      ok-text="Yes"
      cancel-text="No"
      @confirm="emitApprove"
      v-if="selectedRecord.status === 'PENDING' || selectedRecord.status === 'VERIFIED'"
      >
        <a-button class="mr-2" type="primary">
        Approve
        </a-button>
      </a-popconfirm>
    </div>
    </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ApprovalTable',
  props: {
    data: Array,
    loading: Boolean,
    session: Number,
    actionRequiredOptions: Array,
    rolesetting: { type: Object },
  },
  computed: {
    submittedByName() {
      const user = this.selectedRecord.submitted_by
      return user ? `${user.first_name} ${user.last_name}` : '-'
    },
    columns() {
      return [
        {
          title: 'SL. No',
          scopedSlots: { customRender: 'sno' },
          width: 60,
        },
        {
          title: 'Approval Type',
          dataIndex: 'approval_type',
          scopedSlots: { customRender: 'approval_type' },
          width: 160,
        },
        {
          title: 'Submitted By',
          dataIndex: 'submitted_by',
          scopedSlots: { customRender: 'submitted_by' },
          width: 150,
        },
        {
          title: 'Submitted At',
          dataIndex: 'submitted_at',
          scopedSlots: { customRender: 'submitted_at' },
          width: 150,
        },
        {
          title: 'Assigned To',
          dataIndex: 'assigned_to',
          scopedSlots: { customRender: 'assigned_to' },
          width: 140,
        },
        {
          title: 'Class',
          scopedSlots: { customRender: 'class' },
          width: 90,
        },
        {
          title: 'Section',
          scopedSlots: { customRender: 'section' },
          width: 90,
        },
        {
          title: 'Action Required',
          dataIndex: 'action_required',
          scopedSlots: { customRender: 'action_required' },
          filters: (this.actionRequiredOptions &&
        this.actionRequiredOptions.map(option => ({
          text: option,
          value: option,
        }))) || [],
          onFilter: (value, record) => record.action_required === value,
          width: 130,
        },
        {
          title: 'Status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 100,
        },
        {
          title: 'Action',
          scopedSlots: { customRender: 'action' },
          width: 90,
        },
      ]
    },

  },
  methods: {
    closeModal() {
      this.viewModalVisible = false
    },
    emitApprove() {
      this.$emit('approve', this.selectedRecord.id)
    },
    showViewModal(record) {
      this.selectedRecord = record
      this.viewModalVisible = true
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY hh:mm A')
    },
    formatDateOnly(date) {
      return moment(date).format('DD-MM-YYYY')
    },
    statusColor(status) {
      switch (status) {
        case 'PENDING':
          return 'orange'
        case 'VERIFIED':
          return 'blue'
        case 'APPROVED':
          return 'green'
        default:
          return 'default'
      }
    },
  },
  data() {
    return {
      viewModalVisible: false,
      selectedRecord: {},
      currentPage: 1,
      pageSize: 50,
      selectedRowKeys: [],
    }
  },
}
</script>
